(() => {
  const SELECTOR = '.amr-matcha-info[data-section-id]';

  function $(root, sel) {
    return root.querySelector(sel);
  }
  function $all(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }

  function initSection(root) {
    if (!root || root.__amrMiInit) return;
    root.__amrMiInit = true;

    const items = $all(root, '[data-amr-item]');
    if (!items.length) return;

    const autoplayEnabled = String(root.dataset.autoplay) === 'true';
    const intervalMsRaw = parseInt(root.dataset.autoplayInterval, 10);
    const intervalMs = Number.isFinite(intervalMsRaw) && intervalMsRaw >= 500 ? intervalMsRaw : 2000;

    // Sync CSS animation duration to the configured interval
    root.style.setProperty('--amr-mi-interval', `${intervalMs}ms`);

    let activeIndex = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')));
    if (activeIndex === -1) activeIndex = 0;

    let timer = null;
    let paused = false;

    function restartProgress(el) {
      const bar = el.querySelector('.amr-matcha-info__progress-bar');
      if (!bar) return;
      bar.style.animation = 'none';
      // force reflow to restart animation
      // eslint-disable-next-line no-unused-expressions
      bar.offsetHeight;
      bar.style.animation = '';
      bar.style.animationDuration = `${intervalMs}ms`;
    }

    function syncHeights() {
      if (window.innerWidth < 992) {
        const rightCol = root.querySelector('.amr-matcha-info__right');
        if (rightCol) rightCol.style.height = '';
        return;
      }

      const leftCol = root.querySelector('.amr-matcha-info__left');
      const rightCol = root.querySelector('.amr-matcha-info__right');
      if (!leftCol || !rightCol) return;

      rightCol.style.height = `${leftCol.offsetHeight}px`;
    }

    function setActive(nextIndex, { fromUser = false } = {}) {
      const clamped = ((nextIndex % items.length) + items.length) % items.length;
      activeIndex = clamped;

      items.forEach((el, idx) => {
        if (idx === activeIndex) el.classList.add('is-active');
        else el.classList.remove('is-active');
      });

      const activeEl = items[activeIndex];

      restartProgress(activeEl);
      syncHeights();

      if (fromUser) {
        // On interaction, restart autoplay cadence
        if (autoplayEnabled && !paused) startAutoplay();
      }
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled) return;
      timer = window.setInterval(() => {
        if (paused) return;
        setActive(activeIndex + 1);
      }, intervalMs);
    }

    // Bind events
    items.forEach((el, idx) => {
      el.addEventListener('pointerenter', () => {
        paused = true;
        stopAutoplay();
        setActive(idx, { fromUser: true });
      });
      el.addEventListener('pointerleave', () => {
        paused = false;
        startAutoplay();
      });
      el.addEventListener('click', () => {
        setActive(idx, { fromUser: true });
      });
      el.addEventListener('focus', () => {
        paused = true;
        stopAutoplay();
        setActive(idx, { fromUser: true });
      });
      el.addEventListener('blur', () => {
        paused = false;
        startAutoplay();
      });
    });

    // Set initial state and start
    setActive(activeIndex);
    syncHeights();
    window.addEventListener('resize', syncHeights);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  // Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', (evt) => {
    const root = evt.target && evt.target.querySelector ? evt.target.querySelector(SELECTOR) : null;
    if (root) initSection(root);
  });
})();

